import { GroupByMode, ID, UserSettings } from '@griply/types';

// Falls back to the legacy todoSorting so reorders from a pre-migration client still surface.
export const getUpcomingCustomOrder = (
  settings: UserSettings | undefined | null,
): Record<ID, ID[]> => {
  const migrated = settings?.customTaskOrder?.upcoming?.[
    GroupByMode.UpcomingDeadline
  ] as Record<ID, ID[]> | undefined;

  if (migrated && Object.keys(migrated).length) {
    return migrated;
  }
  return settings?.todoSorting ?? {};
};
